<template>
    <div class="virtual">
        <van-nav-bar
            title="虚拟设备"
            left-arrow
            :fixed="true"
            @click-left="$router.push({name:'mainFunc'})"
            />
        <LiteMap
            :mapOptions="mapOptions"
            :userInfo="userInfo"
            :virtualList="virtualList"
            :stations="stations"
            @initMap="initMap"
        />
        <van-button type="info" class="current" @click="gobackCurrent"
            >返回实时数据</van-button
        >
        <AlarmList @viewAlarm="viewAlarm" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { drawStation, drawVirtual, drawStationInfowindow } from "./utils";
import LiteMap from "./LiteMap";
import AlarmList from "./AlarmList";
export default {
    name: "VirtualDevice",
    components: {
        LiteMap,
        AlarmList
    },
    data() {
        return {
            mapOptions: {
                width: "100%",
                height: "50%",
                zoom: 17
            },
            start_time: moment()
                .subtract(24, "hours")
                .format("YYYY-MM-DD HH:mm:ss"),
            end_time: moment().format("YYYY-MM-DD HH:mm:ss"),
            infoMarker: []
        };
    },
    computed: {
        ...mapState(["userInfo", "virtualList", "stations"]),
        intensity() {
            return new colorIntensity.getIntensity({
                dataType: "pm10",
                max: 700,
                min: 0,
                colorType: "static"
            });
        }
    },
    watch: {
        stations() {
            this.drawStations();
        },
        virtualList() {
            this.drawVirtuals();
        }
    },
    mounted() {
        // this.$store.dispatch("getVirtualDevice", this.userInfo.GroupId);
        this.$store.dispatch("getVirtualDevice", this.userInfo.StationGroupIds);
        this.$store.dispatch("getUserStations", {
            groups: this.userInfo.devGroupIds,
            timep: "min"
        });
        this.$store.dispatch("getAlarmList", {
            start_time: this.start_time,
            end_time: this.end_time
        });
        this.drawStation = drawStation();
        this.drawVirtual = drawVirtual();
        this.drawStationInfowindow = drawStationInfowindow();
    },
    methods: {
        initMap(map) {
            this.map = map;
        },
        drawStations() {
            if (this.stations && this.stations.length > 0) {
                this.stations.forEach(item => {
                    const color =
                        this.intensity.bgcolor.getColor(item.sensor.pm10) ||
                        "gray";
                    const marker = new this.drawStation(item, 15, color);
                    /* marker.addEventListener('click', function (evt) {
                        alert(2222)
                    }) */
                    this.map.addOverlay(marker);
                    marker.addEventListener('touchstart',(e) => {
                        for(let item of this.infoMarker) {
                            item.hide()
                        }
                        const infoMarker = new this.drawStationInfowindow(marker._info, 15);
                        this.map.addOverlay(infoMarker);
                        this.infoMarker.push(infoMarker)
                    });
                });
            }
        },
        drawVirtuals() {
            if (this.virtualList && this.virtualList.length > 0) {
                this.virtualList.forEach(item => {
                    const virtualMarker = new this.drawVirtual(item, 20);
                    this.map.addOverlay(virtualMarker);
                });
            }
        },
        gobackCurrent() {
            this.$store.dispatch("getUserStations", {
                groups: this.userInfo.devGroupIds,
                timep: "min"
            });
        },
        viewAlarm(time) {
            this.$store.dispatch("getUserStations", {
                groups: this.userInfo.devGroupIds,
                timep: "hour",
                timepoint: time
            });
        }
    }
};
</script>

<style scoped>
.virtual {
    width: 100%;
    height: 100%;
}
.current {
    position: absolute;
    top: 46%;
    left: 0;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/application/virtual/VirtualDevice.vue